<span
  *ngIf="
    criteria.min_value != null &&
    criteria.max_value != null &&
    criteria.min_value != criteria.max_value
  "
  [ngClass]="{ 'purple-text': colourText }"
>
  Between
  {{
    column.metric_labels
      ? column.metric_labels[convertString(criteria.min_value)]
      : criteria.min_value
  }}
  and
  {{
    column.metric_labels
      ? column.metric_labels[convertString(criteria.max_value)]
      : criteria.max_value
  }}
</span>
<span
  *ngIf="criteria.min_value != null && criteria.max_value == null"
  [ngClass]="{ 'purple-text': colourText }"
>
  <ng-container *ngIf="!displaySymbols">Greater than or equal to </ng-container>
  <ng-container *ngIf="displaySymbols">>=</ng-container
  ><!--
  -->{{
    column.metric_labels
      ? column.metric_labels[convertString(criteria.min_value)]
      : criteria.min_value
  }}
</span>
<span
  *ngIf="criteria.min_value == null && criteria.max_value != null"
  [ngClass]="{ 'purple-text': colourText }"
>
  <ng-container *ngIf="!displaySymbols">Less than or equal to </ng-container>
  <ng-container *ngIf="displaySymbols"><=</ng-container
  ><!--
  -->{{
    column.metric_labels
      ? column.metric_labels[convertString(criteria.max_value)]
      : criteria.max_value
  }}
</span>
<span
  *ngIf="
    criteria.min_value != null &&
    criteria.max_value != null &&
    criteria.min_value == criteria.max_value
  "
  [ngClass]="{ 'purple-text': colourText }"
>
  <ng-container *ngIf="!displaySymbols">Equal to </ng-container>
  <ng-container *ngIf="displaySymbols">=</ng-container
  ><!--
  -->{{
    column.metric_labels
      ? column.metric_labels[convertString(criteria.min_value)]
      : criteria.min_value
  }}
</span>
